import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountDeliveryAddress, AccountDeliveryAddressPronto } from '../../models/account-delivery-address';
import { CheckOutService } from '../../services/checkout.service';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { MyAccountService } from '../../services/myAccount.service';
import { catchError, exhaustMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { of } from 'rxjs';
import { merge } from 'rxjs';



declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-delievery-address',
    templateUrl: './delievery-address.component.html',
    styleUrls: ['./delievery-address.component.css']
})
export class DelieveryAddressComponent implements OnInit, OnDestroy {

    title = 'Delivery Locations';
    deliveryAddressList: AccountDeliveryAddress[];

    selectedAddress: AccountDeliveryAddress;
    address: AccountDeliveryAddress;
    filterResultArr: any;
    filterInput: string; // binds to ngModel of filter input
    hasEmptyFilterResult = false; // checking the return value by calling filter pipe
    loadContent = false;

    ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private router: Router,
        private checkOutService: CheckOutService,
        private myAccountService: MyAccountService,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {


        merge(of(''), this.checkOutService.deliveryAddressBook$.asObservable()).pipe(
            tap(() => {
                this.loadContent = false;
            }),
            exhaustMap(() => this.checkOutService.getDeliveryAddressBook()),
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: AccountDeliveryAddressPronto[]) => {
            this.deliveryAddressList = [];
            res.map((value, key) => {
                let combined = '';
                [value.deliveryAddressLine2, value.deliveryAddressLine3, value.deliveryAddressLine4, value.deliveryAddressLine5, value.deliveryAddressLine6, value.postcode].forEach(element => {
                    if (element && typeof element !== 'undefined') {
                        combined += `${element}, `;
                    }
                });
                this.address = {
                    companyName: value.deliveryAddressLine1,
                    attnOrRef: value.deliveryAddressLine7,
                    // Begin Address value
                    addressLine1: value.deliveryAddressLine2,
                    addressLine2: value.deliveryAddressLine3,
                    addressLine3: value.deliveryAddressLine4,
                    suburb: value.deliveryAddressLine5,
                    state: value.deliveryAddressLine6,
                    postcode: value.postcode,
                    // End Address value
                    phone: value.phone,
                    naType: value.naType,
                    action: 'U',
                    combinedAddress: combined.slice(0, -2)
                };
                this.deliveryAddressList.push(this.address);
                this.deliveryAddressList.sort(function (a, b) {
                    if (a.companyName < b.companyName) { return -1; }
                    if (a.companyName > b.companyName) { return 1; }
                    return 0;
                });

                this.loadContent = true;
            });

        }, (error: any) => {
            console.log(error);
            this.loadContent = true;
        })

    }

    onChange() {
        this.filterResultArr = new TablefilterMultiplePipe().transform(this.deliveryAddressList, ['companyName'], this.filterInput);
        if (this.filterResultArr.length === 0) {
            this.hasEmptyFilterResult = true;
        } else {
            this.hasEmptyFilterResult = false;
        }
    }

    close() {
        this.router.navigateByUrl('/myAccount');
    }

    gotoEditMood(address: AccountDeliveryAddress): void {
        this.myAccountService.monitorAddressChange(address);
        this.router.navigate(['editdeliverylocation'], { relativeTo: this.activatedRoute });
    }

    newAddress(): void {
        this.router.navigate(['adddeliverylocation'], { relativeTo: this.activatedRoute });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
